import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/auth";
import userReducer from "./reducers/user";
import leadReducer from "./reducers/lead";
import teamReducer from "./reducers/team";
import meetingReducer from "./reducers/meeting";
import bookingReducer from "./reducers/booking";
import developerReducer from "./reducers/developer";
import queryReducer from "./reducers/query";
import queryDataReducer from "./reducers/queryData";
import { notificationApi } from "./services/notification";
import { hrmsNotificationApi } from "./services/hrmsNotifications";
import { creditLeavesApi } from "./services/creditLeavesData";
import { latestAuthApi } from "./services/authService";
import { attendaceApi } from "./services/attendance";
import { leaveApi } from "./services/leaves";
import { inactiveApi, userApi, hierarchyUsersApi } from "./services/user";
import {
  leadsApi,
  meetingHistory,
  statusHistory,
  summaryApi,
  topDeveloper,
  topPerformance,
  leadQualityDashboard,
  leadProjectWiseDashboard,
  closingLeadProjectWiseDashboard,
} from "./services/leads";
import { leadDetailsApi } from "./services/leadDetail";
import { assignUsersAPi } from "./services/assigningUsers";
import { meetingsApi } from "./services/meetings";
import { meetingDetailsApi } from "./services/meetingDetail";
import { bookingsApi } from "./services/booking";
import { meetingsFrBApi } from "./services/meetingsForBooking";
import { bookingDetailsApi } from "./services/bookingDetail";
import {
  dashboardDataApi,
  dashboardPnLDataApi,
} from "./services/dashboardData";
import { dashboardMeetingApi } from "./services/meetingDashboard";
import { dashboardBookingApi } from "./services/bookingDashboard";
import { commissionDataApi } from "./services/commissionData";
import { projectsList } from "./services/project";
import { projectDetailsApi } from "./services/projectDetails";
import { expenseList } from "./services/expense";
import { expenseCatList } from "./services/expenseCat";
import { expenseCatDetailsApi } from "./services/expenseCatDetails";
import { expenseListDetailsApi } from "./services/expenseListDetails";
import { invoiceList } from "./services/Invoice";
import { invoiceDetailsApi } from "./services/invoiceDetails";
import { teamRoleExpense } from "./services/teamRoleExpense";
import { assignedHistory } from "./services/leads";
import { leadPoolApi } from "./services/leadPool";
import { incentiveList, teamIncentiveList } from "./services/Incentive";
import {
  incentiveDetailsApi,
  teamIncentiveDetailsApi,
} from "./services/incentiveDetails";

import { hrmsSettingsApi } from "./services/hrmsSettings";
import { referralList } from "./services/referral";
import { referralListDetailsApi } from "./services/referralListDetails";
import { userPermissionApi } from "./services/user";
import {
  departmentApi,
  departmentDetailsApi,
  employeesByDeptApi,
} from "./services/department";
import { upcomingEvents, eventsApi, eventDetailsApi } from "./services/events";
import { eventRegApi, eventRegDetailsApi } from "./services/eventRegister";

export const store = configureStore({
  reducer: {
    [notificationApi.reducerPath]: notificationApi.reducer,
    [hrmsNotificationApi.reducerPath]: hrmsNotificationApi.reducer,
    [creditLeavesApi.reducerPath]: creditLeavesApi.reducer,
    [latestAuthApi.reducerPath]: latestAuthApi.reducer,
    [attendaceApi.reducerPath]: attendaceApi.reducer,
    [hrmsSettingsApi.reducerPath]: hrmsSettingsApi.reducer,
    [leaveApi.reducerPath]: leaveApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [hierarchyUsersApi.reducerPath]: hierarchyUsersApi.reducer,
    [leadsApi.reducerPath]: leadsApi.reducer,
    [meetingsApi.reducerPath]: meetingsApi.reducer,
    [leadDetailsApi.reducerPath]: leadDetailsApi.reducer,
    [meetingDetailsApi.reducerPath]: meetingDetailsApi.reducer,
    [assignUsersAPi.reducerPath]: assignUsersAPi.reducer,
    [bookingsApi.reducerPath]: bookingsApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [meetingsFrBApi.reducerPath]: meetingsFrBApi.reducer,
    [bookingDetailsApi.reducerPath]: bookingDetailsApi.reducer,
    [dashboardDataApi.reducerPath]: dashboardDataApi.reducer,
    [dashboardPnLDataApi.reducerPath]: dashboardPnLDataApi.reducer,
    [dashboardMeetingApi.reducerPath]: dashboardMeetingApi.reducer,
    [dashboardBookingApi.reducerPath]: dashboardBookingApi.reducer,
    [commissionDataApi.reducerPath]: commissionDataApi.reducer,
    [projectsList.reducerPath]: projectsList.reducer,
    [projectDetailsApi.reducerPath]: projectDetailsApi.reducer,
    [expenseList.reducerPath]: expenseList.reducer,
    [expenseCatList.reducerPath]: expenseCatList.reducer,
    [expenseCatDetailsApi.reducerPath]: expenseCatDetailsApi.reducer,
    [expenseListDetailsApi.reducerPath]: expenseListDetailsApi.reducer,
    [invoiceList.reducerPath]: invoiceList.reducer,
    [invoiceDetailsApi.reducerPath]: invoiceDetailsApi.reducer,
    [teamRoleExpense.reducerPath]: teamRoleExpense.reducer,
    [assignedHistory.reducerPath]: assignedHistory.reducer,
    [statusHistory.reducerPath]: statusHistory.reducer,
    [meetingHistory.reducerPath]: meetingHistory.reducer,
    [leadPoolApi.reducerPath]: leadPoolApi.reducer,
    [incentiveList.reducerPath]: incentiveList.reducer,
    [teamIncentiveList.reducerPath]: teamIncentiveList.reducer,
    [incentiveDetailsApi.reducerPath]: incentiveDetailsApi.reducer,
    [teamIncentiveDetailsApi.reducerPath]: teamIncentiveDetailsApi.reducer,
    [topPerformance.reducerPath]: topPerformance.reducer,
    [topDeveloper.reducerPath]: topDeveloper.reducer,
    [inactiveApi.reducerPath]: inactiveApi.reducer,
    [summaryApi.reducerPath]: summaryApi.reducer,
    [leadQualityDashboard.reducerPath]: leadQualityDashboard.reducer,
    [leadProjectWiseDashboard.reducerPath]: leadProjectWiseDashboard.reducer,
    [closingLeadProjectWiseDashboard.reducerPath]:
      closingLeadProjectWiseDashboard.reducer,
    [referralList.reducerPath]: referralList.reducer,
    [referralListDetailsApi.reducerPath]: referralListDetailsApi.reducer,
    [userPermissionApi.reducerPath]: userPermissionApi.reducer,
    [departmentApi.reducerPath]: departmentApi.reducer,
    [departmentDetailsApi.reducerPath]: departmentDetailsApi.reducer,
    [employeesByDeptApi.reducerPath]: employeesByDeptApi.reducer,
    [upcomingEvents.reducerPath]: upcomingEvents.reducer,
    [eventDetailsApi.reducerPath]: eventDetailsApi.reducer,
    [eventRegApi.reducerPath]: eventRegApi.reducer,
    [eventRegDetailsApi.reducerPath]: eventRegDetailsApi.reducer,
    // [summaryOfEOI.reducerPath]: summaryOfEOI.reducer,

    auth: authReducer,
    users: userReducer,
    leads: leadReducer,
    meetings: meetingReducer,
    teams: teamReducer,
    bookings: bookingReducer,
    developers: developerReducer,
    query: queryReducer,
    advanceSearch: queryDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    [...getDefaultMiddleware()].concat(
      notificationApi.middleware,
      hrmsNotificationApi.middleware,
      creditLeavesApi.middleware,
      latestAuthApi.middleware,
      attendaceApi.middleware,
      hrmsSettingsApi.middleware,
      leaveApi.middleware,
      userApi.middleware,
      hierarchyUsersApi.middleware,
      leadsApi.middleware,
      leadDetailsApi.middleware,
      assignUsersAPi.middleware,
      meetingsApi.middleware,
      meetingDetailsApi.middleware,
      bookingsApi.middleware,
      meetingsFrBApi.middleware,
      bookingDetailsApi.middleware,
      dashboardDataApi.middleware,
      dashboardPnLDataApi.middleware,
      dashboardMeetingApi.middleware,
      dashboardBookingApi.middleware,
      commissionDataApi.middleware,
      projectsList.middleware,
      projectDetailsApi.middleware,
      expenseList.middleware,
      expenseCatList.middleware,
      expenseCatDetailsApi.middleware,
      expenseListDetailsApi.middleware,
      invoiceList.middleware,
      invoiceDetailsApi.middleware,
      // expenseCatList.middleware,
      teamRoleExpense.middleware,
      assignedHistory.middleware,
      statusHistory.middleware,
      meetingHistory.middleware,
      leadPoolApi.middleware,
      incentiveList.middleware,
      teamIncentiveList.middleware,
      incentiveDetailsApi.middleware,
      teamIncentiveDetailsApi.middleware,
      topPerformance.middleware,
      topDeveloper.middleware,
      inactiveApi.middleware,
      summaryApi.middleware,
      leadQualityDashboard.middleware,
      leadProjectWiseDashboard.middleware,
      closingLeadProjectWiseDashboard.middleware,
      referralList.middleware,
      referralListDetailsApi.middleware,
      userPermissionApi.middleware,
      departmentApi.middleware,
      departmentDetailsApi.middleware,
      employeesByDeptApi.middleware,
      upcomingEvents.middleware,
      eventsApi.middleware,
      eventDetailsApi.middleware,
      eventRegApi.middleware,
      eventRegDetailsApi.middleware
    ),
});
